module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.contactDialog = true;
        _vm.selectedCustomer = null;
        _vm.selectedKey = null
      }
    }
  }, [_vm._v("Add Contact")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredContacts,
      "search": _vm.search,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.selectedKey = props.item.key;
              _vm.contactDialog = true;
              _vm.selectedCustomer = props.item.Customer
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.customerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.EmailAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Mobile))]), _vm._v(" "), _c('td', [(props.item.Fleet) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-chip', {
          attrs: {
            "slot": "activator",
            "small": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("mdi-truck")])], 1), _vm._v(" "), _c('span', [_vm._v("Fleet")])], 1) : _vm._e(), _vm._v(" "), (props.item.Comms) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-chip', {
          attrs: {
            "slot": "activator",
            "small": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("mdi-phone")])], 1), _vm._v(" "), _c('span', [_vm._v("Comms")])], 1) : _vm._e(), _vm._v(" "), (props.item.Accounts) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-chip', {
          attrs: {
            "slot": "activator",
            "small": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("mdi-cash-100")])], 1), _vm._v(" "), _c('span', [_vm._v("Accounts")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteContact(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('contact-edit-dialog', {
    attrs: {
      "customer": _vm.selectedCustomer,
      "customers": _vm.customers,
      "contactDialog": _vm.contactDialog,
      "contactID": _vm.selectedKey
    },
    on: {
      "getContacts": _vm.getContacts,
      "setCustomer": _vm.updateCustomer,
      "update:contactDialog": function($event) {
        _vm.contactDialog = $event
      },
      "update:contact-dialog": function($event) {
        _vm.contactDialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c4befb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contacts.vue
// module id = 757
// module chunks = 1